export default {
    workflows: {
        title: "Workflow",
        description: "Gestisci workflow personalizzati per gli agenti AI",
        newWorkflow: "Nuovo Workflow",
        searchPlaceholder: "Cerca per nome...",
        statusPlaceholder: "Filtra per stato",
        type: {
            default: "Predefinito",
            custom: "Personalizzato",
        },
        status: {
            active: "Attivo",
            inactive: "Inattivo",
            draft: "Bozza",
        },
        headers: {
            name: "Nome",
            type: "Tipo",
            status: "Stato",
            nodesCount: "Nodi",
            createdAt: "Creato",
            actions: "Azioni",
        },
        actions: {
            view: "Visualizza",
            edit: "Modifica",
            delete: "Elimina",
        },
        detail: {
            back: "Indietro",
            edit: "Modifica",
            nodesCount: "Nodi",
            edgesCount: "Connessioni",
            createdAt: "Creato il",
            visualization: "Visualizzazione Workflow",
        },
        notFound: {
            title: "Workflow Non Trovato",
            message: "Il workflow richiesto non esiste.",
            backToList: "Torna alla Lista",
        },
        noData: {
            title: "Nessun Workflow",
            message: "Crea il tuo primo workflow per iniziare.",
        },
        modal: {
            confirmDelete: "Elimina Workflow",
            confirmDeleteMessage: "Sei sicuro di voler eliminare questo workflow? Questa azione non può essere annullata.",
        },
        new: {
            title: "Nuovo Workflow",
        },
        edit: {
            title: "Modifica Workflow",
        },
        editor: {
            addNode: "Aggiungi Nodo",
            deleteNode: "Elimina Nodo",
            cancel: "Annulla",
            save: "Salva",
            nodeProperties: "Proprietà Nodo",
            nodeType: "Tipo",
            nodeLabel: "Label",
            agentType: "Tipo Agente",
            actionType: "Tipo Azione",
            condition: "Condizione",
            nodeTypes: {
                start: "Nodo Start",
                agent: "Nodo Agente",
                decision: "Nodo Decisione",
                action: "Nodo Azione",
                end: "Nodo End",
            },
            defaultLabels: {
                start: "Start",
                agent: "Agente",
                decision: "Decisione",
                action: "Azione",
                end: "End",
            },
            agentTypes: {
                postino: "Postino/Mailer",
                classificatore: "Classificatore",
                parser: "Parser",
                validatore: "Validatore",
            },
            actionTypes: {
                notification_in_app: "Notifica In-App",
                notification_email: "Notifica Email",
                notification_both: "Notifica Completa",
            },
            operators: {
                equals: "Uguale",
                contains: "Contiene",
                exists: "Esiste",
                not_equals: "Non Uguale",
                not_contains: "Non Contiene",
            },
            savingWorkflow: "Salvataggio workflow...",
            workflowSaved: "Workflow salvato con successo!",
            relatedAccounts: "Account Correlati",
            searchAccounts: "Cerca account per nome, email o partita IVA...",
            noAccountsFound: "Nessun account trovato",
            taxId: "Partita IVA",
            selectedCount: "{{count}} selezionati",
            close: "Chiudi",
        },
        savingChanges: "Salvataggio in corso...",
        allSaved: "Tutto salvato!",
    },
};
